import * as React from 'react'
import { StyleUnorderedList, StyledList, StyledLink } from './UnorderedList.style'
import { Text } from '$views/components/Text'
import { TextFontWeight } from '$utils/theme/font'

interface Props {
  options?: string[]
  componentList?: any[]
  card?: boolean
  menu?: boolean
  weight?: TextFontWeight
}

export const UnorderedList: React.FC<Props> = ({ options, componentList, card, menu, weight }) => {
  const [expanded, handleExpanded] = React.useState<boolean>(false)

  const showMore = () => handleExpanded(expanded!)

  return (
    <>
      {componentList ? (
        <StyleUnorderedList card={card}>
          {componentList.map((component, index) => (
            <StyledList idList={index} key={index} card={card}>
              {component}
            </StyledList>
          ))}
        </StyleUnorderedList>
      ) : (
        <>
          <StyleUnorderedList card={card}>
            {options.map((text, index) => (
              <StyledList idList={index} visible={expanded} card={card} key={index}>
                <Text menu={menu} weight={weight}>
                  {text}
                </Text>
              </StyledList>
            ))}
          </StyleUnorderedList>
          {card && <StyledLink onClick={showMore} visible={expanded} length={options.length} />}
        </>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/List/UnordererList/UnorderedList.tsx